import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ConnectorBlock = ({ isMobile, active }) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: isMobile ? 'auto' : '100%',
            padding: 10,
            alignSelf: 'center',
        }}>
            <FontAwesomeIcon
                icon={isMobile ? ['fas', 'arrow-down'] : ['fas', 'arrow-right']}
                size={isMobile ? '2x' : '4x'}
                color={active ? '#fff' : '#ccc'}
                style={active ? { filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.5))' } : undefined}
            />
        </div>
    );
};

export default ConnectorBlock;
